import React, { useState } from 'react';
import { Icon } from './Icon';
import { Colors } from '@/constants/Colors';

interface LogoImageProps {
  uri?: string | null;
  size?: number;
  style?: React.CSSProperties;
}

export function LogoImage({ uri, size = 40, style }: LogoImageProps) {
  const [error, setError] = useState(false);
  const showPlaceholder = !uri || error;

  if (showPlaceholder) {
    return (
      <div
        style={{
          width: size,
          height: size,
          backgroundColor: `${Colors.primary}15`,
          borderRadius: 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          ...style,
        }}
      >
        <Icon name="shield" size={size * 0.6} color={Colors.primary} />
      </div>
    );
  }

  return (
    <img
      src={uri}
      alt=""
      style={{ width: size, height: size, objectFit: 'contain', flexShrink: 0, ...style }}
      onError={() => setError(true)}
    />
  );
}
